<template>
  <div class="ryxx_box">
    <Tabs v-if="!showXx" value="name1">
      <Tab-pane label="从业人员信息" name="name1">
        <div class="search_box">
          <div>
            <div>
              人员姓名：<Input
                v-model="form.name"
                placeholder=""
                style="width: 180px"
              ></Input>
            </div>
            <div>
              证书编号：<Input
                v-model="form.certno"
                placeholder=""
                style="width: 180px"
              ></Input>
            </div>
            <div class="btn1" @click="toSearch">查询</div>
            <div class="btn2" @click="toReset">重置</div>
          </div>
          <div>
            <div class="btn1" @click="addPersonnel">人员增加申请</div>
            <div class="btn3" @click="toLogoff">人员转出申请</div>
            <div class="btn4" @click="addExcellence">评优申请提交</div>
          </div>
        </div>
        <div class="cell_box">
          <div class="cell th">
            <div v-for="(it, i) in th" :key="i">{{ it }}</div>
          </div>
          <div
            v-for="(it, i) in ryList"
            v-if="ryList.length > 0"
            :key="i"
            class="cell td"
          >
            <div>
              <checkbox v-model:checked="it.isCheck" />
            </div>
            <div>
              {{ params.pageSize * params.pageNo - params.pageSize + i + 1 }}
            </div>
            <div>{{ it.name }}</div>
            <div>{{ it.fineUser == "1" ? "是" : "否" }}</div>
            <div>{{ it.sfz }}</div>
            <div>{{ it.certno }}</div>
            <div>{{ it.shrq }}</div>
            <div>{{ it.yxqq }}</div>
            <div>
              {{
                it.iscancel == "0"
                  ? "有效"
                  : it.iscancel == "1"
                    ? "失效"
                    : it.iscancel
              }}
            </div>
            <div style="cursor: pointer" @click="goDetail(it)">查看</div>
            <div style="cursor: pointer" @click="goStudy(it)">查看</div>
          </div>
          <div v-if="ryList.length == 0" class="common_excel_no_more">
            暂无内容~
          </div>
        </div>
        <Page
          v-if="ryList.length != 0"
          :current="params.pageNo"
          :page-size="params.pageSize"
          :total="total"
          class="common_page_box"
          show-total
          @on-change="changePage"
        ></Page>
      </Tab-pane>
    </Tabs>
    <Tabs class="sh_box" style="margin-top: 10px" value="name1">
      <Tab-pane label="申请人员信息" name="name1">
        <div class="search_box">
          <div>
            <div>
              人员姓名：<Input
                v-model="formSh.name"
                placeholder=""
                style="width: 180px"
              ></Input>
            </div>
            <div>
              审核状态：
              <el-select
                v-model="formSh.status"
                placeholder="请选择审核状态"
                style="width: 180px; height: 25px"
              >
                <el-option
                  v-for="(item, index) in shList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="btn1" @click="toSearchSh">查询</div>
            <div class="btn2" @click="toResetSh">重置</div>
          </div>
        </div>
        <div>
          <el-table
            v-loading="shLoding"
            :cell-style="{ padding: '10px' }"
            :data="ryShList"
            :header-cell-style="{
              lineHeight: '42px',
              height: '42px',
              padding: 0,
              backgroundColor: '#49b3ff',
              color: '#515a6e',
            }"
            stripe
            style="width: 100%"
          >
            <el-table-column
              align="center"
              label="序号"
              type="index"
              width="100"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="姓名"
              prop="name"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="手机号"
              prop="phone"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="身份证号码"
              prop="idCard"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="审核状态"
              prop="status"
              show-overflow-tooltip
              width="120"
            >
              <template slot-scope="scope">
                {{
                  shList.find((item) => item.value == scope.row.status).label
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="审核不通过原因"
              prop="rejectcd"
              show-overflow-tooltip
              width="330"
            >
              <template slot-scope="scope">
                {{
                  scope.row.rejectcd
                    ? scope.row.rejectcd == "3"
                      ? scope.row.othRejReason
                      : rejectcd.find(
                          (item) => item.value == scope.row.rejectcd,
                        ).label
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="填报日期"
              prop="lrrq"
              show-overflow-tooltip
              width="120"
            ></el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template #default="scope">
                <!--                <el-button type="text" @click="goShDetail(scope.row)"-->
                <!--                  >查看详情-->
                <!--                </el-button>-->
                <el-button
                  v-if="scope.row.status == '2' && scope.row.isZf !== '1'"
                  type="text"
                  @click="goShDetail(scope.row)"
                  >修改
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <Page
          v-if="ryShList.length !== 0"
          :current="paramsSh.pageNo"
          :page-size="paramsSh.pageSize"
          :total="totalSh"
          class="common_page_box"
          show-total
          @on-change="changePageSh"
        ></Page>
      </Tab-pane>
    </Tabs>
    <detailModal ref="detailModal"></detailModal>
    <vipLogin ref="vipbox"></vipLogin>

    <Modal
      v-model="showAlert"
      :mask-closable="true"
      class="model_box"
      scrollable
      width="300px"
    >
      <div style="font-size: 18px; padding: 40px">请选择要转出的从业人员！</div>
    </Modal>
    <Modal
      v-model="showAlertAddExcellence"
      :mask-closable="true"
      class="model_box"
      scrollable
      width="400px"
    >
      <div style="font-size: 18px; padding: 40px">请选择要评优的从业人员！</div>
    </Modal>

    <logoffModal ref="logoffModal"></logoffModal>
    <AddExcellence ref="AddExcellence"></AddExcellence>
    <!--    人员增加申请-->
    <AddPersonnel
      ref="AddPersonnelRef"
      :rejectcd="rejectcd"
      :shList="shList"
      @success="toResetSh"
    ></AddPersonnel>
    <div v-if="showXx">
      <el-button @click="backXx">返回</el-button>
      <xx :studentData="{ studentId: studentId }"></xx>
    </div>
  </div>
</template>

<script>
import vipLogin from "@/components/vip_login.vue";
import xx from "./xx/index.vue";
import detailModal from "./detail.vue";
import logoffModal from "./logoff.vue";
import AddExcellence from "./addExcellence.vue";
import AddPersonnel from "./addPersonnel.vue";
import { getCompanyCyrys, getCyry, cyryReviewListApi } from "@/api/home/index";

export default {
  name: "home",
  components: {
    vipLogin,
    detailModal,
    logoffModal,
    AddExcellence,
    AddPersonnel,
    xx,
  },
  data() {
    return {
      th: [
        "#",
        "序号",
        "姓名",
        "优秀人员",
        "身份证号码",
        "证书编号",
        "审核日期",
        "发证日期",
        "是否有效",
        "证书",
        "培训记录",
      ],
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      form: {
        name: "",
        certno: "",
      },
      ryList: [],
      xh_userInfo: {
        user: {
          username: "",
        },
      },
      showAlert: false,
      showAlertAddExcellence: false,
      showXx: false,
      studentId: "",
      // 人员申请信息
      ryShList: [],
      totalSh: 0,
      paramsSh: {
        pageNo: 1,
        pageSize: 10,
      },
      formSh: {
        name: "",
        status: "",
      },
      shList: [
        { label: "待审核", value: "0" },
        { label: "审核通过", value: "1" },
        { label: "审核不通过", value: "2" },
      ],
      rejectcd: [
        { label: "上传资料与示例不符", value: 1 },
        { label: "上传资料不清晰", value: 2 },
        { label: "资料不在有效期内", value: 4 },
        { label: "照片不清晰", value: 5 },
        { label: "学历不符合要求", value: 6 },
        { label: "公司名称、参保单位、在职证明单位不统一", value: 7 },
        { label: "其他", value: 3 },
      ],
      shLoding: false,
    };
  },
  mounted() {
    if (this.$Cookies.get("xh_userInfo")) {
      this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
    }
    this.getCyry();
    this.getCyrySh();
  },
  methods: {
    changePage(e) {
      this.params.pageNo = e;
      this.getCyry();
    },
    getCyry() {
      getCompanyCyrys({
        ...this.params,
        ...this.form,
        dw: this.xh_userInfo.user.dwmc,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          let info = res.result.records;
          if (info.length > 0) {
            info.map((v) => {
              //v.sfz = handleIdCard(v.sfz);
              v.isCheck = false;
            });
          }
          this.ryList = info;
          this.total = res.result.total;
        } else if (res.code == 401) {
          this.$refs["vipbox"].showLogin = true;
        }
      });
    },
    toSearch() {
      this.params.pageNo = 1;
      this.getCyry();
    },
    toReset() {
      this.form = {};
      this.params.pageNo = 1;
      this.getCyry();
    },
    toLogoff() {
      let names = [];
      let stuids = [];
      this.ryList.forEach((item) => {
        console.log("========item======", item);
        if (item.isCheck) {
          names.push(item.name);
          stuids.push(item.stuUUID);
        }
      });
      if (stuids.length == 0) {
        this.showAlert = true;
        return false;
      }

      let formData = { names: names.join(","), stuids: stuids.join(",") };
      this.$refs["logoffModal"].showPop = true;
      this.$refs["logoffModal"].formData = JSON.stringify(formData);
    },
    addExcellence() {
      let names = [];
      let reviewRecords = [];
      this.ryList.forEach((item) => {
        console.log("========item======", item);
        if (item.isCheck) {
          names.push(item.name);
          reviewRecords.push(item.id);
        }
      });
      if (reviewRecords.length == 0) {
        this.showAlertAddExcellence = true;
        return false;
      }

      let formData = {
        names: names.join(","),
        reviewRecords: reviewRecords,
      };
      this.$refs["AddExcellence"].showPop = true;
      this.$refs["AddExcellence"].formData = JSON.stringify(formData);
    },
    goDetail(it) {
      this.$refs["detailModal"].showPop = true;
      this.$refs["detailModal"].certno = it.certno;
    },
    goStudy(it) {
      this.showXx = true;
      this.studentId = it.stuUUID;
      console.log("tokens", this.tokens);
      // this.$router.push({name: 'cyry', params: {studentId: it.stuUUID, token: tokens}})
    },
    /* 人员申请信息 start*/
    goShDetail(row) {
      // 修改审核不通过数据
      this.$refs.AddPersonnelRef.dialogVisible = true;
      this.$refs.AddPersonnelRef.setData(row);
    },
    changePageSh(e) {
      this.paramsSh.pageNo = e;
      this.getCyrySh();
    },
    toSearchSh() {
      this.paramsSh.pageNo = 1;
      this.getCyrySh();
    },
    toResetSh() {
      this.formSh = {};
      this.paramsSh.pageNo = 1;
      this.getCyrySh();
    },
    getCyrySh() {
      console.log("this.formsh", this.formSh);
      this.shLoding = true;
      cyryReviewListApi({
        ...this.paramsSh,
        ...this.formSh,
        dw: this.xh_userInfo.user.dwmc,
      })
        .then((res) => {
          if (res.code == 200 || res.code == 0) {
            let info = res.result.records || [];
            this.ryShList = info;
            this.totalSh = res.result.total;
          } else if (res.code == 401) {
            this.$refs["vipbox"].showLogin = true;
          }
        })
        .finally(() => {
          this.shLoding = false;
        });
    },
    // 新增从业人员
    addPersonnel() {
      this.$refs.AddPersonnelRef.dialogVisible = true;
      this.$refs.AddPersonnelRef.setData({});
    },
    /* 人员申请信息 end*/
    backXx() {
      this.showXx = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-tabs-nav .ivu-tabs-tab {
  width: 200px;
  text-align: center;
  font-size: 18px;
}

.ryxx_box {
  margin: 10px 20px;
  // width: 100%;
  // max-width: 1000px;

  .search_box {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    font-size: 14px;
    margin: 20px 0;

    > div {
      display: flex;

      > div {
        margin: 10px;
        white-space: nowrap;
        cursor: pointer;
      }
    }

    .btn1 {
      background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
      color: #fff;
      padding: 5px 15px;
    }

    .btn2 {
      background: #767676;
      color: #fff;
      padding: 5px 15px;
    }

    .btn3 {
      background: red;
      color: #fff;
      padding: 5px 15px;
      //float: right;
      //margin-left: auto;
      //margin-right: 10px;
    }

    .btn4 {
      background: #49b3ff;
      color: #fff;
      padding: 5px 15px;
      //float: right;
      //margin-left: auto;
      //margin-right: 10px;
    }
  }

  .cell_box {
    margin-top: 20px;

    .cell {
      display: flex;
      width: 100%;
      white-space: nowrap;
      font-size: 15px;
      padding: 10px 0;
      text-align: center;
      border-left: 1px solid #eee;
      border-right: 1px solid #eee;

      > div:first-child {
        width: 5%;
      }

      > div:nth-child(2) {
        width: 5%;
      }

      > div:nth-child(3) {
        width: 10%;
      }

      > div:nth-child(4) {
        width: 5%;
      }

      > div:nth-child(5) {
        width: 15%;
      }

      > div:nth-child(6) {
        width: 15%;
      }

      > div:nth-child(7) {
        width: 10%;
      }

      > div:nth-child(8) {
        width: 10%;
      }

      > div:nth-child(9) {
        width: 10%;
      }
      > div:nth-child(10) {
        width: 5%;
      }
      > div:nth-child(11) {
        width: 10%;
      }
    }

    .th {
      background-color: #49b3ff;
    }

    .td {
      // cursor: pointer;
    }

    .td:hover {
      background-color: #eee;
    }

    .td:nth-child(odd) {
      background-color: #d8d8d8;
    }

    .td:nth-child(even) {
      border-bottom: 1px solid #eee;
    }
  }

  .sh_box {
    /deep/ .el-input--suffix .el-input__inner {
      height: 35px;
    }

    /deep/ .el-input__icon {
      line-height: 35px;
    }
  }
}

.model_box {
  /deep/ .ivu-modal-body {
    padding: 0;
  }

  /deep/ .ivu-modal-footer,
  /deep/ .ivu-modal-header {
    padding: 30px 50px;
    display: none;
  }
}
</style>
